module.exports = __webpack_public_path__ + "static/media/binoculars.151ac617.svg";